// extracted by mini-css-extract-plugin
export default {"tasksContainer":"tasks_tasksContainer__CVwbw"};